module.exports = __webpack_public_path__ + "img/jeffs-explanation.49afacac.png";